import { useQueryParams } from '@fs/zion-router'
import React, { useMemo } from 'react'
import { Breadcrumbs } from '@fs/zion-ui'
import { usePlaceReportsPageData } from '../../PlaceReportsProvider'
import { getLocaleName } from '../../placeReportsHelper'

export default function PlaceReportsBreadCrumbs() {
  const { getCountryAndRegion, getRegion, getDivision } = usePlaceReportsPageData()
  const { query } = useQueryParams()
  const { region, country, divisions, division } = query

  const addBreadcrumb = (condition, text, to, crumbs) => {
    if (condition) {
      const lastCrumb = crumbs[crumbs.length - 1]
      const newTo = lastCrumb ? `${lastCrumb.to}${to}` : to
      crumbs.push({ text, to: newTo })
    }
  }

  const breadcrumbs = useMemo(() => {
    const crumbs = [{ text: 'World', to: '' }]
    const regionName = getLocaleName(getRegion(region)?.name)
    addBreadcrumb(region, `Region: ${regionName}`, `?&region=${region}`, crumbs)
    const nativeLang = getCountryAndRegion(country)?.country?.native_lang
    const countryName = getLocaleName(getCountryAndRegion(country)?.country?.name, nativeLang)
    addBreadcrumb(country, `Country: ${countryName}`, `&country=${country}`, crumbs)
    addBreadcrumb(divisions, 'Divisions', `&divisions=true`, crumbs)
    const divisionName = getLocaleName(getDivision(division)?.division?.name, nativeLang)
    addBreadcrumb(division, `Division: ${divisionName}`, `&division=${division}`, crumbs)

    return crumbs
  }, [region, country, divisions, division, getRegion, getCountryAndRegion, getDivision])

  return <Breadcrumbs breadcrumbs={breadcrumbs} />
}
